import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/401', { queryParams: { returnUrl: state.url } }]);
    return false;
  }

  const account = authService.getAccount();
  authService.setUserDetails({
    email: account?.username ?? '',
    username: account?.name ?? account?.username ?? '',
    isAdmin: authService.isAdmin(),
    hasAccess: authService.getRoles().length > 0,
  });

  if (!('roles' in route.data)) {
    return true;
  }

  const isAuthorized = authService.isAuthorized(route.data['roles']);
  if (!isAuthorized) {
    router.navigate(['/403'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  return true;
};
